<template>
    <div id="GatherAmountInfo">
      <div class="title">
        <span>垃圾收集量</span>
      </div>
      <dv-decoration-2 style="height:10px;" />
      <check-date @getDate="getDate"/>
      <div id="detail" class="detail">

      </div>
      <div class="per-capita">
        <p><span>人均&nbsp;&nbsp;</span><span v-text="cooper"></span><span>&nbsp;&nbsp;kg</span></p>
      </div>
    </div>
</template>

<script>
    import CheckDate from './CheckDate';
    import echarts from 'echarts'

    export default {
      name: "GatherAmount",
      components: {
        CheckDate
      },
      data(){
        return{
          option: {},
          cooper: 0,
        }
      },
      methods:{
        createData(date){
          let streetId = localStorage.getItem("streetId")
          if (!streetId) {
            streetId = JSON.parse(localStorage.getItem("USER")).streetId;
          }
          let params = {};
          params.streetId = streetId;
          params.date = date;
          this.$get('/data/showCollectiveLens',{
            ...params
          }).then((r)=>{
            let data = r.data;
            if(data.code != 200){
              this.$message.error("权限不足");
            } else {
              let bukIndex = 0;
              let weightTotal = 0;
              let dataInfo = [
                { name: '易腐垃圾', value: 0 },
                { name: '可回收垃圾', value: 0 },
                { name: '有害垃圾', value: 0 },
                { name: '其他垃圾', value: 0 }
              ];
              let id = 0;
              let totalHouse = 0;
              data.data.forEach(function (value,index) {
                bukIndex = value.bukIndex;
                weightTotal = value.weightTotal;
                id = value.id;
                let dateItem = {};
                dataInfo.forEach(function (info) {
                  if(info.name == "易腐垃圾"){
                    if(bukIndex == 1){
                      totalHouse += id;
                    }
                  }else if(info.name == "可回收垃圾"){
                    if(bukIndex == 2){
                      totalHouse += id;
                    }
                  }else if(info.name == "有害垃圾"){
                    if(bukIndex == 3){
                      totalHouse += id;
                    }
                  }else if(info.name == "其他垃圾"){
                    if(bukIndex == 4){
                      totalHouse += id;
                    }
                  }
                });
                dateItem.value = weightTotal;
                dataInfo.push(dateItem);
              });
              this.configOption(dataInfo);
              let myChart = echarts.init(document.getElementById('detail'));
              // myChart.clear();
              myChart.setOption(this.option);
              myChart.on('mouseover',(e) => {
                let cooper = (e.value / totalHouse).toFixed(2);
                this.cooper = cooper;
              });
            }
          });
        },
        configOption(dataInfo){
          this.option =  {
            title: {
              text: ''
            },
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            color: ['#40F276','#408AF7','#F85E52','#4E5253'],
            legend: {
              orient: 'vertical',
              left: 0,
              top: '10%',
              itemWidth: 20,
              itemHeight: 10,
              textStyle: {
                fontSize: 12
              },
              itemGap: 20,
              data: [
                {name: '易腐垃圾',textStyle: {color: '#40F276'}},
                {name: '可回收垃圾',textStyle: {color: '#408AF7'}},
                {name: '有害垃圾',textStyle: {color: '#F85E52'}},
                {name: '其他垃圾',textStyle: {color: '#4E5253'}},
              ]
            },
            series: [
              {
                name: '垃圾收集量',
                type: 'pie',
                radius: ['50%', '70%'],
                center: ['60%', '50%'],
                avoidLabelOverlap: false,
                label: {
                  show: true,
                  position: 'outside',
                  color: '#FFFFFF',
                  formatter: '{c}kg'
                },
                labelLine: {
                  show: true,
                  length: 10,
                  length2: 20
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '14'
                  }
                },
                data: dataInfo
              }
            ]
          };
        },
        getDate(date){
          this.createData(date);
        }
      },
      mounted() {
        const {createData} = this;
        createData();
        const timer = setInterval(createData, 60000);
        this.$once('hook:beforeDestroy',function () {
          clearInterval(timer);
        });
      }
    }
</script>

<style lang="less" scoped>
  #GatherAmountInfo{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px;

    .title{
      width: 100%;
      text-align: center;
      font-size: 1.1em;
      color: #ffffff;
    }

    .detail{
      border-top: 2px solid rgba(1, 153, 209, 0.5);
      border-bottom: 2px solid rgba(1, 153, 209, 0.5);
      width: 100%;
      height: 70%;
    }

    .per-capita{
      width: 100%;
      height: 20%;
      text-align: center;
      line-height: 20%;
    }

    .per-capita p{
      width: 100%;
      height: 100%;
      line-height: 50px;
    }

    .per-capita span{
      font-size: 1.2em;
      color: #7ec699;
      font-weight: bold;
      text-shadow:3px 1px 4px #7ec699;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/datav/GatherAmount.vue